import { z } from 'zod';
import { bestProductTypeMap } from '../type';
import { CoerceToBooleanSchema } from '../../../shared/schema/boolean';

export const bestProductTypeSchema = z.nativeEnum(bestProductTypeMap);

const bestProductSchema = z.object({
  /**
   * 랭킹 타입 (실시간, 주간, 월간)
   */
  rank_type: bestProductTypeSchema,

  /**
   * 선택한 대카테고리, `undefined`이면 전체 카테고리임
   */
  cate_list_id: z.coerce.number().optional(),

  /**
   * 품절 상품 제외
   */
  exclude_sold_out: CoerceToBooleanSchema.optional(),

  limit: z.coerce.number(),

  is_random: CoerceToBooleanSchema.optional(),

  include_watcher_count: CoerceToBooleanSchema.optional(),
});

export type BestProductQueryParams = z.infer<typeof bestProductSchema>;

export const validateBestProductQueryParams = (query: unknown) => {
  return bestProductSchema.parse(query);
};
